import { ReactComponent as BigXIcon } from "../../../../src/assets/icons/BigXIcon.svg";
import { ReactComponent as BigCheckIcon } from "../../../../src/assets/icons/BigCheckIcon.svg";

export type ModalType = "success" | "error" | "confirmation";

interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  type: ModalType;
  title: string;
  message: string;
  primaryAction?: {
    text: string;
    onClick: () => void;
    variant?: "primary" | "secondary" | "danger";
  };
  secondaryAction?: {
    text: string;
    onClick: () => void;
    variant?: "primary" | "secondary" | "danger";
  };
  showCloseButton?: boolean;
}

export default function ConfirmModal({ isOpen, onClose, type, title, message, primaryAction, secondaryAction, showCloseButton = true }: ConfirmModalProps) {

  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case "success":
        return <BigCheckIcon className="w-16 h-16 text-successVar" />;
      case "error":
        return <BigXIcon className="w-20 h-20 text-red-500" />;
      case "confirmation":
        return <BigXIcon className="w-20 h-20 text-red-500" />;
      default:
        return null;
    }
  };

  const getTitleColor = () => {
    switch (type) {
      case "success":
        return "text-primaryVar-700";
      case "error":
        return "text-red-500";
      case "confirmation":
        return "text-red-600";
      default:
        return "text-gray-800";
    }
  };

  const getButtonVariant = (variant?: string) => {
    switch (variant) {
      case "primary":
        return "bg-primaryVar text-white hover:bg-primaryVar/80";
      case "secondary":
        return " bg-primaryVar  text-white border border-primaryVar ";
      case "danger":
        return "bg-red-500 text-white hover:bg-red-600";
      default:
        return "bg-white text-primaryVar  border border-primaryVar";
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center  justify-center bg-black bg-opacity-50 max-[700px]:items-end">
      <div className="bg-white rounded-2xl w-full max-w-[538px] p-6 shadow-lg md:max-w-[538px] max-h-[310px]  max-[700px]:rounded-b-none max-[700px]:w-full">
        <div className="flex flex-col gap-5 h-full justify-between">
          <div className="flex flex-col items-center gap-4">
            {getIcon()}
            <h2 className={`font-bold text-xl mt-2 ${getTitleColor()}`}>
              {title}
            </h2>
          </div>

          <p className="text-gray-600 text-base font-medium text-center">{message}</p>

          <div className="flex flex-row gap-4 mt-1 justify-end">
            {secondaryAction && (
              <button
                onClick={secondaryAction.onClick}
                className={`rounded-xl px-6 h-10 flex items-center justify-center font-medium transition-all ${getButtonVariant(
                  secondaryAction.variant
                )}`}
              >
                {secondaryAction.text}
              </button>
            )}

            {primaryAction && (
              <button
                onClick={primaryAction.onClick}
                className={`rounded-xl px-6 h-10 flex items-center justify-center font-medium transition-all ${getButtonVariant(
                  primaryAction.variant
                )}`}
              >
                {primaryAction.text}
              </button>
            )}

            {showCloseButton && !primaryAction && !secondaryAction && (
              <button
                onClick={onClose}
                className="rounded-xl bg-primaryVar text-white px-6 h-10 flex items-center justify-center font-medium hover:bg-primaryVar/80 transition-all"
              >
                بستن
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};